import * as React from "react";
import { useTheme } from "styled-components";

import { Icon, style } from "./Symbolicons";

const CaretLeft = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        d={
          props.variant === "line"
            ? "M13.561 6.831a.667.667 0 0 1 .938.945l-.06.059L9.679 12l4.76 4.165c.256.224.3.6.114.874l-.051.066c-.224.256-.6.3-.875.114l-.066-.05-5.333-4.667a.667.667 0 0 1-.06-.944l.06-.06 5.333-4.667Z"
            : "M13.021 7.056 8 12l5.021 4.943c.528.52 1.388.52 1.916 0a1.32 1.32 0 0 0 0-1.886L11.83 12l3.106-3.058c.256-.252.396-.587.396-.943s-.14-.69-.396-.942a1.37 1.37 0 0 0-1.916 0Z"
        }
        fill={props.color || theme.palette.grey600}
      />
    </svg>
  );
};

export { CaretLeft };
